module.exports = __webpack_public_path__ + "static/elephant-5_PLACEHOLDER-d55c12443ece270ac2c5eec9d2714268.jpg";